<template>
  <v-container>
    <div id="task-container">
      <!-- alterar header de historico -->
      <header class="service-data">
        <template v-if="currentScreen === 'task-list'">
          <div class="left-data">
            <v-icon color="black" @click="returnScreen">mdi-chevron-left</v-icon>
            <div class="ml-1">
              <p class="service-description">{{ serviceOrder.service_order_type?.description }}</p>
              <p class="car-description">{{ serviceOrder.vehicle?.description ?? 'Não especificado' }}</p>
            </div>
          </div>
          <img v-if="serviceOrder.vehicle?.vehicle_plate_photo_url" :src="serviceOrder.vehicle?.vehicle_plate_photo_url" style="height: 37px" />
          <img v-else :src="require('@/assets/plate_placeholder.png')" style="height: 37px" />
        </template>
        <template v-else>
          <div class="left-data">
            <v-icon color="black" @click="returnScreen">mdi-chevron-left</v-icon>
            <div class="ml-1">
              <p class="service-description">{{ currentScreen === 'task-intervals' ? 'Intervalos' : 'Mídias' }}</p>
              <p class="car-description">{{ user.name }}</p>
            </div>
          </div>
          <img v-if="user?.picture_url" class="user-image" :src="user?.picture_url" />
          <v-icon v-else class="user-image" size="16" style="background-color: #e3e3e3">mdi-account</v-icon>
        </template>
      </header>

      <section v-if="currentScreen === 'task-list'" class="task-list">
        <TaskCard
          v-for="(task, index) in serviceOrderTasks"
          :task="task"
          :key="`${task.id}-task-list-${index}`"
          @change-screen="changeCurrentScreen"
        />
      </section>

      <TaskIntervalList v-if="currentScreen === 'task-intervals'" />

      <TaskMediasList v-if="currentScreen === 'task-medias'" />

      <footer v-if="currentScreen === 'task-list'" class="task-list-footer">
        <div class="d-flex">
          <img v-if="user?.picture_url" class="user-image" :src="user?.picture_url" />
          <v-icon v-else class="user-image" size="16" style="background-color: #e3e3e3">mdi-account</v-icon>

          <div>
            <p class="user-name mb-0">{{ user?.name }}</p>
            <div class="d-flex">
              <v-icon color="#4a5568" size="20">mdi-timer-outline</v-icon>
              <span class="task-time ml-1">{{ `${totalTime} ・ ` }}</span>
              <v-icon color="#4a5568" size="20">mdi-check</v-icon>
              <span class="task-time ml-1">{{ finishedTasksLabel }}</span>
            </div>
          </div>
        </div>

        <v-btn class="add-task-bnt" color="#41A982" elevation="0">
          <v-icon color="#fff" size="32" @click="openModalAddTask">mdi-plus</v-icon>
        </v-btn>
      </footer>
    </div>
    <ModalAddTask :isActive="isModalAddTaskActive" :service-order-id="view_service_order_id" @close="closeModalAddTask" />

    <v-dialog v-model="isLoadingTask" persistent width="300" class="loader-service-order">
      <v-card class="pt-5 pb-2" color="primary" dark>
        <v-card-text>
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TaskCard from '../../components/Task/TaskCard';
import ModalAddTask from '../../components/Task/ModalAddTask';
import TaskIntervalList from '../../components/Task/TaskIntervalList';
import TaskMediasList from '../../components/Task/TaskMediasList';

export default {
  name: 'TaskList',
  props: {
    view_service_order_id: Number
  },
  components: { ModalAddTask, TaskCard, TaskIntervalList, TaskMediasList },
  data() {
    return {
      isModalAddTaskActive: false,
      isModalDeleteTaskActive: false,
      tasks: [],
      user: null,
      currentScreen: 'task-list'
    };
  },
  computed: {
    serviceOrder() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    serviceOrderTasks() {
      return this.$store.getters['ServiceOrderTask/getServiceOrderTaskList'];
    },
    finishedTasksLabel() {
      if (!this.serviceOrderTasks) return '-/-';
      return `${this.serviceOrderTasks.filter((task) => task.status === 'finished').length}/${this.serviceOrderTasks.length}`;
    },
    taskIntervalActive() {
      return this.$store.getters['ServiceOrderTask/getServiceOrderTaskIntervalActive'];
    },
    taskIntervalActiveTotalTime() {
      return this.$store.getters['ServiceOrderTask/getTaskIntervalActiveTotalTime'];
    },
    totalTime() {
      return this.calculateTotalTime(this.serviceOrderTasks, this.taskIntervalActiveTotalTime);
    },
    isLoadingTask() {
      return this.$store.getters['ServiceOrderTask/isLoadingTask'];
    }
  },
  methods: {
    openModalAddTask() {
      this.isModalAddTaskActive = true;
    },
    closeModalAddTask() {
      this.isModalAddTaskActive = false;
    },

    returnScreen() {
      if (this.currentScreen === 'task-intervals' || this.currentScreen === 'task-medias') {
        this.changeCurrentScreen('task-list');
        return;
      }

      const taskWorking = this.serviceOrderTasks.find((task) => task.status === 'working');

      if (taskWorking) {
        this.$toast.warning('Existe uma tarefa em andamento, não se esqueça de pausa-la antes de sair.');
        return;
      }

      this.$store.dispatch('ServiceOrderTask/resetState');
      this.$emit('return', !this.view_service_order_id);
    },
    changeCurrentScreen(screen) {
      this.currentScreen = screen;
    },
    calculateTotalTime(tasks, taskIntervalActiveTotalTime) {
      let totalMilliseconds = 0;

      tasks.forEach((task) => {
        task.task_intervals.forEach((interval) => {
          if (interval?.id === this.taskIntervalActive?.id) {
            totalMilliseconds += taskIntervalActiveTotalTime;
          } else {
            const startDate = new Date(interval.start_date);
            const endDate = new Date(interval.end_date);
            startDate.setSeconds(0, 0);
            endDate.setSeconds(0, 0);
            totalMilliseconds += endDate - startDate;
          }
        });
      });

      const totalMinutes = Math.floor(totalMilliseconds / 60000);
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;

      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    }
  },
  async mounted() {
    if (this.view_service_order_id) {
      await this.$store.dispatch('ServiceOrder/getServiceOrder', this.view_service_order_id);
      await this.$store.dispatch('ServiceOrderTask/getServiceOrderTaskList', this.view_service_order_id);
    }

    this.user = this.$store.getters['Auth/user'];
  }
};
</script>

<style lang="scss">
.container {
  padding: 0;
}
#task-container {
  .service-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px 12px 20px;
    position: fixed;
    top: 0;
    background-color: #fff;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid #e2e8f0;

    .left-data {
      display: flex;
      align-items: center;

      p {
        margin: 0;
      }

      .service-description {
        font-size: 16px;
        font-weight: 400;
        color: #4a5568;
      }

      .car-description {
        font-size: 16px;
        font-weight: 700;
        color: #2d3748;
      }
    }
  }

  .task-list {
    padding: 18px;
    background-color: #edf2f7;
    height: calc(100vh - 150px);
    margin-top: 65px;
    overflow-y: auto;
  }

  .task-list-footer {
    background-color: #fff;
    bottom: 0;
    display: flex;
    padding: 16px 16px 48px 16px;
    position: fixed;
    width: 100%;
    justify-content: space-between;
    border-top: 1px solid #e2e8f0;

    .user-name {
      color: #4a5568;
      font-weight: 600;
      font-size: 16px;
    }

    .task-time {
      color: #4a5568;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
    }

    .add-task-bnt {
      height: 56px;
      min-width: 56px;
      padding: 0;
      border-radius: 6px;
      .v-icon {
        font-size: 36px;
      }
    }
  }
}

.user-image {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 10px;
}
</style>
